<template>
  <div class="pro-plan">
    <CustomTitle :title="mytitle"/>
    <div class="table-header df-c" :style="{
      fontSize: fontsize + 'px',
      lineHeight: (fontsize * 1.25) + 'px'
    }">
      <span class="index" style="flex:0.5">#</span>
      <span v-for="(item, index) in tableHeader" :key="index" 
      :style="{flex: item === '工号' || item === '图号' ? '2.1' : (item === '机台' ? '0.5' : '1')}">
      {{ item }}
    </span>
    </div>
    <div class="scroll-chart">
      <vue-seamless-scroll :data="tableData" class="warp" :class-option="classOption">
        <template v-for="(item, index) in tableData">
          <div class="table-item df-c" :key="index" ref="TableItem" 
            :style="{
              fontSize: fontsize + 'px',
              lineHeight: (fontsize * 1.25) + 'px'
            }">
            <span class="index" style="flex:0.5">{{index+1}}</span>          
            <span class="overflow-text" style="flex:0.5">{{item.ETProMac}}</span>
            <span class="overflow-text" style="flex:2.1">{{item.PartNu?item.PartNu.slice(-safePnlen):item.PartNu}}</span>
            <span class="overflow-text" style="flex:2.1">{{item.PartTitle?item.PartTitle.slice(-safePnlen):item.PartTitle}}</span>
            <span class="overflow-text" >{{item.Proset}}</span>
            <span class="overflow-text">{{item.DisHours}}</span>
            <span class="overflow-text" :style="{color:echoColor(item.CurDEP)}">{{item.CurDEP}}</span>
            <span class="overflow-text">{{item.StatusStr}}</span>
            <!-- <span class="overflow-text">{{item.ETProST}}</span> -->
          </div>
        </template>
      </vue-seamless-scroll>
    </div>
  </div>
</template>

<script>
import CustomTitle from '@/components/CustomTitle'
import vueSeamlessScroll from 'vue-seamless-scroll'
import config from '@/js/config'
import moment from 'moment'

export default {
  name: 'ProductionSchedule',  // Changed from ShippingSchedule to match content
  data () {
    return {
      compid: -1,
      dept: '',
      mytitle: "生产排程",  // Changed from "今日排程" to be more accurate
      tableHeader: [
        '机台', '工号', '图号', '工时 部门', '状态'
      ],
      tableData: [],
      classOption: {
        step: 0.5
      },
      requestTimer: null,
      isShowPo: '',
      isShowMo: '',
      nowDay: moment().format('YYYY-MM-DD'),
      afterThreeDay: moment().add(2, 'days').format('YYYY-MM-DD'),
      requestUrl: '',
      retryTimer: null,
      classst: '',
      dst: '',
      ded: '',
      fontsize: "",
      pnlen:11

    }
  },
  computed: {
  safePnlen() {
    return Math.abs(parseInt(this.pnlen)) || 11; // 确保是正整数，默认 11
  }},
  methods: {
    getPOparts() {
      clearTimeout(this.retryTimer)
      this.compid = window.localStorage.getItem('bsmcompid')
      this.dept = window.localStorage.getItem('bsmdept')
      this.classst = window.localStorage.getItem('bsmdayst')
      if(this.classst === 'undefined') {
        this.classst = '8:00'
      }

      var ttp = window.localStorage.getItem('bsmisbrushpcs')
      if(ttp > 0) {
        this.classOption.step = ttp
      }

      var fnt = window.localStorage.getItem('bsmisfontsize')
      if(fnt > 10) {
        this.fontsize = fnt
      }

      this.axios({
        method: 'post',
        url: this.requestUrl + '/admin.php/Bigsreen/ProPlanFun?datekind=0&compid=' + 
             this.compid + '&dst=' + this.dst + '&ded=' + this.ded + 
             '&dept=' + this.dept + '&classst=' + this.classst
      })
      .then((Response) => {
        var data = JSON.parse(Response.data)
        this.tableData = data['rows']
        this.tableHeader = data['head']
      })
      .catch((error) => {
        console.log("Error in proplan: ", error)
        this.retryTimer = setTimeout(() => {
          this.getPOparts()
        }, config.retryTime)
      })
    },
    
    echoTime(time) {
      if (time) {
        var timeArr = time.split('-')
        return timeArr[1] + '-' + timeArr[2]
      }
      return ''
    },
    
    echoColor(time) {
      if (!time) {
        return '#fff'
      }
      if (time != this.dept) {
        return '#FFA8B6'
      }
    }
  },
  created() {
    this.requestUrl = window.localStorage.getItem('requestUrl')
    this.pnlen = Number(window.localStorage.getItem('bsmpnlen')) || 11;
    this.getPOparts()
  },
  mounted() {
    this.requestTimer = setInterval(() => {
      this.getPOparts()
    }, 15 * 60 * 1000)  // 15 minutes
  },
  beforeDestroy() {
    clearInterval(this.requestTimer)
    clearTimeout(this.retryTimer)
  },
  components: {
    CustomTitle,
    vueSeamlessScroll
  }
}
</script>

<style scoped lang="less">
.pro-plan {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 8px 8px !important;
  
  .table-header {
    margin-top: 8px;
    background: linear-gradient(0deg, #1b6787 -24.83%, #4aaef7 100%);
    padding: 0 16px;
    border-radius: 8px 8px 0px 0px;
    
    .index {
      width: 20px;
      flex: unset;
    }
    
    span {
      flex: 1;
      padding: 7px 2px;
      text-align: center;
      font-family: 'PingFang SC';
      font-weight: 500;
      color: #ffffff;
      
      &:nth-child(2) {
        flex: 1.7 !important;
      }
    }
  }
  
  .table-item {
    cursor: pointer;
    padding: 0 16px;
    
    .index {
      width: 30px;
      flex: unset;
    }
    
    span {
      flex: 1;
      padding: 5px 2px;
      text-align: center;
      font-family: 'PingFang SC';
      font-weight: 500;
      color: #bae3e6;
      
      &:nth-child(2) {
        flex: 1.7 !important;
      }
    }
  }

  .scroll-chart {
    flex: 1;
    min-height: 100px;
    overflow: hidden;
    border: 1px solid #2dcdff;
    border-top: 0;
    border-radius: 0px 0px 8px 8px;
    
    .warp {
      height: 100%;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/workroomdp/components/Proplan.vue